import ILoteSolicitadoRequest from '../entities/ILoteSolicitadoRequest'
import ILoteSolicitadoResponse from '../entities/LoteSolicitadoResponse'
import { ILoteSolicitadoRepository } from '../repositories/ILoteSolicitadoRepository'

export interface IFindAll {
  execute(dto: ILoteSolicitadoRequest): Promise<ILoteSolicitadoResponse>
}

export default class IFindAllImpl implements IFindAll {
  constructor(
    private readonly loteSolicitadoRepository: ILoteSolicitadoRepository,
  ) {}

  public async execute({
    destino,
    cidadeDestinoIBGE,
    motorista,
    cte,
    origem,
    cidadeOrigemIBGE,
    page,
    placa,
    sort,
    frotistaId,
  }: ILoteSolicitadoRequest): Promise<ILoteSolicitadoResponse> {
    const response = await this.loteSolicitadoRepository.findAll({
      destino,
      motorista,
      cte,
      origem,
      page,
      placa,
      sort:
        sort === 'MAIS RECENTE'
          ? 'DESC'
          : sort === 'MAIS ANTIGO'
          ? 'ASC'
          : undefined,
      frotistaId,
      cidadeDestinoIBGE,
      cidadeOrigemIBGE,
    })

    return response
  }
}
